import styled, { css } from 'styled-components'
// themes
import { colors } from 'themes'

export const ToolbarWrapper = styled('div')`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  background: ${colors.gray190};
  padding: 12px 8px;
  gap: 4px;
  width: 100%;
  border-radius: 0 0 4px 4px;
`

export const ButtonGroup = styled('div')<{ withDivider?: boolean }>`
  display: flex;
  align-items: center;
  gap: 4px;
    
    ${({ withDivider }) => withDivider && css`
      border-right: 1px solid gray;
      padding-right: 4px;
  `}
`

interface ButtonProps {
  isActive?: boolean
}

export const ToolbarButton = styled('button')<ButtonProps>`
  border-radius: 4px;
  cursor: pointer;
  font-size: 18px;
  padding: 0 4px;
  width: 32px;
  height: 32px;
  background: ${({ isActive }) => (isActive ? colors.gray230 : colors.gray190)};
  border: none;
  display: flex;
  justify-content: center;
  align-items: center;

  svg {
    font-size: 20px !important;
  }

  &:hover {
    background: ${colors.gray230};
  }
`

